module.exports = require('./NotesView');
